module.exports = require('./NotesView');
